import {useAgyleConfigStyles} from '../../agyle_configuration';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import React, {useEffect, useState} from 'react';
import useOpenState from '../../../../hooks/useOpenState';
import {setSnackbar} from '../../../../store/reducers/globals';
import Typography from '@mui/material/Typography';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import MessageBox from '../../../../util/messageBox';
import {FormLabel} from '@mui/material';
import AgyleCheckBox from '../../../../components/ui/checkbox/agyleCheckBox';
import {DEFAULT_LOCATION_VALUE_CLEANING_REQUEST} from '../configDefaultValues';

const LocationConfigurationCleaningRequest = ({cfg, handleSaveConfig}) => {
    const classes = useAgyleConfigStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [location, setLocation] = useState(DEFAULT_LOCATION_VALUE_CLEANING_REQUEST);
    const [isModified, setIsModified] = useState(false);

    // Opening states
    const [isWarningOpen, openWarning, closeWarning] = useOpenState(false, true);

    // Load from config
    useEffect(() => {
        if (cfg?.value?.location) {
            setLocation(cfg?.value?.location);
        }
    }, [cfg]);

    const onSave = () => {
        handleSaveConfig('location', location);
        setIsModified(false);
    };

    const onDefault = () => {
        closeWarning();
        setLocation(DEFAULT_LOCATION_VALUE_CLEANING_REQUEST);
        dispatch(setSnackbar({type: 'info', message: t('Default settings restored.')}));
        setIsModified(true);
    };

    const renderSection = (type, title) => {
        const handleChange = (event) => {
            const {checked, name} = event.target;
            setLocation(prevState => ({
                ...prevState,
                [type]: {
                    ...prevState[type],
                    [name]: checked,
                },
            }));
            setIsModified(true);
        };

        return (
            <div className={classes.smallContext}>
                <FormLabel>
                    {title}
                </FormLabel>

                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <AgyleCheckBox
                        name="enabled"
                        label={t('Enabled')}
                        value={location[type].enabled}
                        onChange={handleChange}
                    />

                    <AgyleCheckBox
                        name="auto"
                        label={t('Auto request')}
                        value={location[type].auto}
                        onChange={handleChange}
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            <Typography variant="subtitle2" sx={{marginBottom: '10px'}}>
                {t('Set default behavior for Cleaning Request for individual locations.')}
            </Typography>

            <div>
                {renderSection('ED', t('Emergency Department'))}
                {renderSection('IP', t('Inpatient'))}
            </div>

            <div className={classes.action}>
                <AgyleButton
                    onClick={openWarning}
                    variant="contained"
                >
                    {t('Reset to default')}
                </AgyleButton>

                <AgyleButton
                    onClick={onSave}
                    variant="contained"
                    disabled={!isModified}
                >
                    {t('Save changes')}
                </AgyleButton>
            </div>

            <MessageBox
                open={isWarningOpen}
                onClose={closeWarning}
                title={t('Confirmation')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={onDefault}
                message={t('Are you sure you want to restore the default settings?')}
            />
        </>
    );
};

export default LocationConfigurationCleaningRequest;